import * as PanelBankSectionConfigTypes from '../../state/views/panelBankSectionConfig/types';

/**
 * With the current ref system, we need to continue to use the id from the sectionRef
 * because we are reordering the sectionRefs inside panelBankConfig.
 *
 * While section.__id__ is a stable id, we cannot use this as the unique identifier with the
 * current ref system.
 *
 * @param sectionRef
 * @returns The id of the sectionRef
 */
export const getDndSortableId = (
  sectionRef: PanelBankSectionConfigTypes.Ref
) => {
  return sectionRef.id;
};
